<template>
    <div class="col-12">
        <div
            class="row header pb-2 pt-2"
            :class="backgroundClass"
        >
            <div class="col-1">
                <strong>{{ $t("numberShort") }}</strong>
            </div>
            <div class="col-4">
                <strong>{{ $t("kpiMeasure") }}</strong>
            </div>
            <div class="col-2">
                <strong>{{ $t("timeFrameDays") }}</strong>
            </div>
            <div class="col-2">
                <strong>Status</strong>
            </div>
            <div class="col-2">
                <strong>{{ $t("date") }}</strong>
            </div>
            <div class="col-1">
                <strong>{{ $t("score") }}</strong>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
/* eslint-disable @typescript-eslint/no-unused-vars */

import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';


@Component({
    name: 'phase-header',
})
export default class PhaseHeaderComponent extends Vue {
    @Prop()
    private backgroundClass!: string;

    constructor() {
        super();
    }
}
</script>
